import axios from '../../../../shared/axios/new-api-axios';

import * as actionTypes from '../constants/smses';

const getMessageControlParametersStart = () => {
  return {
    type: actionTypes.SMSES_GET_MESSAGE_CONTROL_PARAMETERS_START,
  };
};

const getMessageControlParametersSuccess = (data) => {
  return {
    type: actionTypes.SMSES_GET_MESSAGE_CONTROL_PARAMETERS_SUCCESS,
    data,
  };
};

const getMessageControlParametersFail = (error) => {
  return {
    type: actionTypes.SMSES_GET_MESSAGE_CONTROL_PARAMETERS_FAIL,
    error,
  };
};

export const getMessageControlParameters = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getMessageControlParametersStart());

      const url = `/sms/get-message-control-parameters`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getMessageControlParametersSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getMessageControlParametersFail(err));
          reject(err);
        });
    });
  };
};

const sendMessageStart = () => {
  return {
    type: actionTypes.SMSES_SEND_MESSAGE_START,
  };
};

const sendMessageSuccess = (data) => {
  return {
    type: actionTypes.SMSES_SEND_MESSAGE_SUCCESS,
    data,
  };
};

const sendMessageFail = (error) => {
  return {
    type: actionTypes.SMSES_SEND_MESSAGE_FAIL,
    error,
  };
};

export const sendMessage = (props) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(sendMessageStart());

      const url = `/sms/send-message`;

      axios
        .post(url, props)
        .then((response) => {
          dispatch(sendMessageSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(sendMessageFail(err));
          reject(err);
        });
    });
  };
};

const getContactPhonesStart = () => {
  return {
    type: actionTypes.GET_CONTACT_PHONES_START,
  };
};

const getContactPhonesSuccess = (data) => {
  return {
    type: actionTypes.GET_CONTACT_PHONES_SUCCESS,
    data: data,
  };
};

const getContactPhonesFail = (error) => {
  return {
    type: actionTypes.GET_CONTACT_PHONES_FAIL,
    error: error,
  };
};

export const getContactPhones = (params) => {
  return (dispatch) => {
    dispatch(getContactPhonesStart());
    const url = `/notes/get-contact-phones`;

    axios
      .get(url, {
        params: params,
      })
      .then((response) => dispatch(getContactPhonesSuccess(response.data)))
      .catch((err) => dispatch(getContactPhonesFail(err)));
  };
};
